import { useRef, useEffect, useState } from "react";

const useOverflow = () => {
  const elementRef = useRef(null);
  const [overflowState, setOverflowState] = useState({
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
  });

  useEffect(() => {
    const checkOverflow = () => {
      if (elementRef.current) {
        const rect = elementRef.current.getBoundingClientRect();
        const overflowState = {
          top: Math.min(0, rect.top),
          left: Math.min(0, rect.left),
          bottom: Math.max(
            0,
            rect.bottom -
              (window.innerHeight || document.documentElement.clientHeight)
          ),
          right: Math.max(
            0,
            rect.right -
              (window.innerWidth || document.documentElement.clientWidth)
          ),
        };

        setOverflowState(overflowState);
      }
    };

    // Check overflow on mount
    checkOverflow();

    // Check overflow on window resize
    window.addEventListener("resize", checkOverflow);
    // Observe changes in the element or its parents
    const observer = new MutationObserver(checkOverflow);
    if (elementRef.current) {
      observer.observe(elementRef.current, {
        attributes: true,
        childList: true,
        subtree: true,
      });
    }
    return () => {
      window.removeEventListener("resize", checkOverflow);
      observer.disconnect();
    };
  }, []);
  const adjustHeight = () => {
    if (elementRef.current && overflowState.bottom > 0) {
      elementRef.current.style.height = `${
        elementRef.current.offsetHeight - overflowState.bottom
      }px`;
    }
  };
  return [elementRef, overflowState, adjustHeight];
};

export default useOverflow;
